export function getMonday(d: string | number | Date) {
  const date = new Date(d);
  const weekDay = date.getDay();
  const diff = date.getDate() - weekDay + (weekDay === 0 ? -6 : 1);
  return new Date(date.setDate(diff));
}

export function parseDateString(dateStr: string) {
  try {
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  } catch {
    console.error('Invalid date format: ', dateStr);
    // ignore errors for now
  }
}

export function getDateString() {
  const d = new Date(Date.now());
  const day = `${d.getDate()}`.padStart(2, '0');
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const year = `${d.getFullYear()}`;
  return `${day}/${month}/${year}`;
}
